import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

export const IconFilter: FC<IconSVGProps> = ({ ...props }) => (
  <IconSVG className="IconFilter" {...props}>
    <svg height="100%" width="32" viewBox="0 0 32 32" fill="currentColor">
      <path
        clipRule="evenodd"
        fillRule="evenodd"
        d="M.839385.249299C1.25399-.115556 1.88587-.0752229 2.25073.339385L13.5 13.1227V26c0 .5523-.4477 1-1 1s-1-.4477-1-1V13.8774L.749299 1.66064C.384444 1.24603.424777.614154.839385.249299ZM31.6606.249299c-.4146-.364855-1.0465-.3245219-1.4113.090086L19 13.1227V26c0 .5523.4477 1 1 1s1-.4477 1-1V13.8774L31.7507 1.66064c.3649-.41461.3245-1.046486-.0901-1.411341Z"
      />
    </svg>
  </IconSVG>
)
